import { render, staticRenderFns } from "./WoundCare.vue?vue&type=template&id=58a268d9&"
import script from "./WoundCare.vue?vue&type=script&lang=js&"
export * from "./WoundCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports